import http from './http';

export default class NewsletterService {
    subscribeAnimal(umbracoNodeId: string | number, payload: any) {
        return http.post(`newsletter/animal/${umbracoNodeId}/subscribe`, payload);
    }

    subscribeEcodisplay(umbracoNodeId: string | number, payload: any) {
        return http.post(`newsletter/ecodisplay/${umbracoNodeId}/subscribe`, payload);
    }

    subscribeNewsletter(umbracoNodeId: string | number, payload: any) {
        return http.post(`newsletter/${umbracoNodeId}/subscribe`, payload);
    }
}

// A singleton instance
export const newsletterService = new NewsletterService();